import enumeration from "./enumeration";

const ProductCreationType = {
  Whole: "WHOLE",
  ProductSet: "PRODUCT_SET",
  Assemble: "ASSEMBLE",
};

export default enumeration(ProductCreationType);
